import api, { handleResponse, handleError } from './api';

const refundService = {
  /**
   * Host-initiated refund against an application.
   *
   *   refundType = 'auto'       → refund each tender to its origin: card-paid back to
   *                               the card (Stripe), wallet-paid back to the wallet (default)
   *   refundType = 'to_card'    → force a Stripe refund to the original card
   *   refundType = 'to_balance' → force a ledger-only credit to the guest's Wallet
   *
   * The $1 PR fee, GST, and Stripe processing fee are non-refundable.
   *
   * @param {string} applicationId
   * @param {'auto'|'to_card'|'to_balance'} refundType
   * @param {string|null} reason
   */
  async issueRefund(applicationId, refundType = 'auto', reason = null) {
    try {
      const response = await api.post('/refunds', { applicationId, refundType, reason });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default refundService;
